import { DIMixins, DIValidators } from "@/core/@types/types";
import { diContainer } from "@/inversify.config";
import { IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";
import useDate from "@/core/plugins/useDate";
import { IF360Validator } from "@/core/validators/F360Validator";

export default function useBannerAvisoBoleto() {
  const isCielo = diContainer
    .get<IF360Validator>(DIValidators.CIELO)
    .handleValidation();
  const isCadis = diContainer
    .get<IF360Validator>(DIValidators.CADIS)
    .handleValidation();
  const userProfileMixin = diContainer
    .get<IUserProfileStorageMixin>(DIMixins.USER_PROFILE_STORAGE)
    .handleGetUserProfile();
  const libDate = useDate();

  const handleData = () => {
    const inicioExibicao = libDate.getNewDate("2024/04/03");
    const fimExibicao = libDate.getNewDate("2025/04/11");
    const currentDate = libDate.getNewDate(null);

    const mostrarModal =
      currentDate >= inicioExibicao && currentDate <= fimExibicao;

    return mostrarModal;
  };

  const handleAllowedPages = () => {
    const location = window.location.href;

    const allowedPage = ["indicadores", "FechamentoDeCaixa", "Despesa"];

    return allowedPage.some((page) => location.includes(page));
  };

  const isClienteHelp = () => {
    const marcas = userProfileMixin?.MarcasEnum;

    if (!marcas) return false;

    const helpEnum = 859;

    return marcas.includes(helpEnum);
  };

  const showBannerBoleto = () => {
    if (!handleData()) return false;

    if (isCielo || isCadis || isClienteHelp()) return false;

    if (!handleAllowedPages()) return false;

    return true;
  };

  return {
    showBannerBoleto
  };
}
